import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityTeam } from "@components/accounts/EntityTeam/EntityTeam";
import { AccountsTableRow } from "../accountsView.types";

export const TeamCell = memo(
    ({ row }: CellContext<ViewTableFeatures, AccountsTableRow, unknown>) => {
        const rowData = row.original;
        if (rowData.account) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                <EntityTeam members={rowData.assignedMembers} />
            </ViewTableCell>
        );
    },
);

TeamCell.displayName = "TeamCell";
